export class Order {
    field: string;
    direction: 'asc' | 'desc';
}
